<template>
    <div class="mt-3">
        <base_location_modal key="qr" extra_type="pwa_qr" :tabs_advanced="tabs_add">

            <template v-slot:location_general_info="{ location, name }">
                <pwa_qr_general_tab :location="location"></pwa_qr_general_tab>
            </template>

            <template v-slot:pwa_location_image="{ location, name }">
                <pwa_location_image :location="location"></pwa_location_image>
            </template>
            <!--
            <template v-slot:pwa_payment_tab="{ location, name }">
                <pwa_payment_tab :is_qr="true" :location="location"></pwa_payment_tab>
            </template>
-->
            <template v-slot:pwa_qr_tab="{ location, name }">
                <pwa_qr_tab :location="location"></pwa_qr_tab>
            </template>


        </base_location_modal>
    </div>
</template>

<script>
import base_location_modal from "../../base/location_modal/base_location_modal";
import pwa_payment_tab from "./tabs/pwa_payment_tab";
import pwa_qr_tab from "./tabs_qr/pwa_qr_tab.vue";
import Pwa_qr_general_tab from "./tabs_qr/pwa_qr_general_tab.vue";
import pwa_location_image from "./tabs/pwa_location_image.vue";

export default {
    name: "pwa_qr_location_modal",
    components : {
        pwa_location_image,
        Pwa_qr_general_tab,
        base_location_modal,

        pwa_payment_tab,
        pwa_qr_tab
    },

    data () {
        return {
            tabs_add : [
                {
                    index : "pwa_location_image",
                    title : this.__t('PWA_IMAGE'),
                },
                /*{
                    index : "pwa_payment_tab",
                    title : this.__t('PWA_PAYMENT'),
                },*/

                {
                    index : "pwa_qr_tab",
                    title : this.__t('PWA_QR'),
                },
            ]
        }
    },
    methods : {

        set_active(tab) {

        },

        get_tab_title(tab) {

        }
    },
    computed: {
        is_qr() {


            return false;
        },
    }
}
</script>

<style scoped>

</style>
